/* Simple browser-based wishlist heart toggle (no account needed).
   Stores liked product IDs in localStorage and reflects state on every
   product card. Uses event delegation so it works for cards loaded later
   (filters, load-more, quick view). */
(function () {
  var KEY = 'ambela_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isLiked(id) { return getList().indexOf(String(id)) !== -1; }

  function paint(root) {
    var hearts = (root || document).querySelectorAll('.product--wishlist[data-wishlist-id]');
    hearts.forEach(function (btn) {
      var id = String(btn.getAttribute('data-wishlist-id'));
      btn.classList.toggle('is-liked', isLiked(id));
      btn.setAttribute('aria-pressed', isLiked(id) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product--wishlist[data-wishlist-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = String(btn.getAttribute('data-wishlist-id'));
    var list = getList();
    var idx = list.indexOf(id);
    if (idx === -1) { list.push(id); } else { list.splice(idx, 1); }
    saveList(list);
    paint();
  });

  document.addEventListener('DOMContentLoaded', function () { paint(); });
  // Re-paint when cards are injected (filters / load more / quick view)
  var mo = new MutationObserver(function () { paint(); });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  paint();
})();
